module.exports = __webpack_public_path__ + "static/media/close.e634f219.svg";